export default {
  "content": "<path d=\"M12.524 0L7 5.524 1.476 0 0 1.476 5.524 7 0 12.524 1.476 14 7 8.476 12.524 14 14 12.524 8.476 7 14 1.476z\" fill=\"#D7D8DE\"/>",
  "attrs": {
    "height": "14",
    "viewBox": "0 0 14 14",
    "width": "14",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};